import { useCanAdministerAIAgents } from "~/pages/manifold-nextgen/hooks/useCanAdministerAIAgents";
import { Agent, AgentAccessLevel } from "~/services/agents";

// Sharing an agent maps to the owner-only `can_share` grant; editors and
// USER-level grants never confer it. Applies uniformly to both scopes — a SYSTEM
// agent is shareable by an owner (an admin-granted `is_manager`), letting them
// adjust grants above the `user:*` baseline. An `admin:agents` caller can share
// any visible agent via the FGA bypass. Drives the Share action and modal.
export const useCanShareAgent = (agent: Agent | undefined): boolean => {
  const isAdmin = useCanAdministerAIAgents();
  return !!agent && (agent.access_level === AgentAccessLevel.OWNER || isAdmin);
};
